import * as yup from "yup";
import { GetErrorObject } from "../Utils";

export const ComponentSchema = yup.object().shape({
  Component: yup
    .string()
    .transform((value) => value || "")
    .required("Component Name is required."),
});

export function ValidateComponent(input) {
  return new Promise(async function (resolve, reject) {
    try {
      ComponentSchema.validate(input, { abortEarly: false })
        .then(function () {
          const data = {
            Component: {
              ...input,
            },
          };
          resolve({ data });
        })
        .catch(function (err) {
          const errors = GetErrorObject(err);
          resolve({ errors });
        });
    } catch (e) {
      reject(e);
    }
  });
}
